(function (ebusy) {

    ebusy.lite = ebusy.lite || {};

    ebusy.lite.clearCredentials = createClearFunction(true);

    $(document).on("hide.bs.modal", createClearFunction(false));

    function createClearFunction(async) {
        return function() {
            ebusy.clearCountdowns();

            return $.ajax({
                type: "POST",
                url: "/clear-lite-credentials",
                async: async
            });
        }
    }

})(window.ebusy = window.ebusy || {});
